import { combineReducers } from 'redux'
import isDesktop from './is-desktop'
import windowWidth from './window-width'
import windowHeight from './window-height'
import useCases from './use-cases'
import currentUseCase from './current-use-case'
import shouldShowUseCases from './should-show-use-cases'

export default combineReducers({
  isDesktop: isDesktop,
  windowWidth: windowWidth,
  windowHeight: windowHeight,
  useCases: useCases,
  currentUseCase: currentUseCase,
  shouldShowUseCases: shouldShowUseCases,
})
